<template>
  <div style="display: flex; flex-direction: column; height: 100%">
    <ag-grid-vue style="width: 100%; height: 100%" class="ag-theme-balham" :gridOptions="gridOptions"
      :columnDefs="columnDefs" :defaultColDef="defaultColDef" :rowData="rowData" :rowHeight="rowHeight"
      :animateRows="true" @first-data-rendered="onFirstDataRendered" @row-clicked="onRowClicked"
      :frameworkComponents="frameworkComponents" :loadingOverlayComponent="loadingOverlayComponent"
      :loadingOverlayComponentParams="loadingOverlayComponentParams" :noRowsOverlayComponent="noRowsOverlayComponent"
      :noRowsOverlayComponentParams="noRowsOverlayComponentParams">
    </ag-grid-vue>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import OverlayLoading from "./overlay_loading";
import OverlayNoRows from "./overlay_no_rows";

import { mapActions } from 'vuex'

export default {
  name: "assignments_datatable",
  components: {
    AgGridVue,
    OverlayLoading,
    OverlayNoRows
  },
  props: {
    rowData: null,
    loadingMessage: { type: String, default: 'Loading...' },
    noRowsMessage: { type: String, default: 'No Rows Found' },
    columns: null,
    type: { type: String, required: true },
    recordType: { type: String, required: false },
    paginationPageSize: { type: Number, default: 5 }
  },

  data() {
    return {
      gridOptions: null,
      gridApi: null,
      columnApi: null,
      columnDefs: null,
      defaultColDef: null,
      rowHeight: null,

      frameworkComponents: null,
      loadingOverlayComponent: null,
      loadingOverlayComponentParams: null,
      noRowsOverlayComponent: null,
      noRowsOverlayComponentParams: null,
    }
  },
  beforeMount() {
    this.gridOptions = {
      suppressCellSelection: false,
      pagination: true,
      paginationPageSize: this.paginationPageSize,
      rowStyle: {
        'border-bottom': 'white 1px solid',
        'border-top': 'white 1px solid',
      },
      // autoHeight: true,
      onColumnResized: this.onColumnResized,
    };

    if (this.type === 'contracts') {
      this.gridOptions.getRowStyle = function (params) {
        if (params.data.is_signed) {
          return { background: '#bbe8cf' }
        }
        else {
          return { background: '#f8d3d3' }
        }
      }
    }

    this.defaultColDef = {
      resizable: true,
      sortable: true,
      filter: true,
      floatingFilter: true,
      filterParams: { newRowsAction: 'keep', buttons: ['reset'], },
      cellStyle: { "white-space": "normal" },
      unSortIcon: true,
      suppressMenu: true,
      autoHeight: true,
      suppressSizeToFit: false,
      flex: 1,
      wrapText: true,     // <-- HERE
    };
    this.frameworkComponents = {
      customLoadingCellRenderer: OverlayLoading,
      customNoRowsOverlay: OverlayNoRows,
    };
    this.loadingOverlayComponent = 'customLoadingCellRenderer';
    this.loadingOverlayComponentParams = { loadingMessage: this.loadingMessage };
    this.noRowsOverlayComponent = 'customNoRowsOverlay';
    this.noRowsOverlayComponentParams = { noRowsMessage: this.noRowsMessage };

    this.columnDefs = this.columns;

    this.$bus.$on('table::reload', ($event) => {
      if ($event.table === 'all_workers' && $event.type === 'delete' && this.type === 'workers') {
        this.rowData.splice(this.$store.state.workers.current_row_id.row_id, 1);
      }
      if ($event.table === 'all_workers' && $event.type === 'update' && this.type === 'workers') {
        this.gridApi.refreshCells({ force: true, rowNodes: [this.$store.state.workers.current_row_id.row_id] })
      }
    });
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
    this.gridColumnApi = this.gridOptions.columnApi;
  },
  methods: {
    ...mapActions(['showRightInfo']),

    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
      params.api.resetRowHeights();
    },
    onColumnResized(params) {
      params.api.resetRowHeights();
    },
    onRowClicked(params) {
      this.showRightInfo({ data: params.data, type: 'workers' });
    }
  },
}
</script>

<style lang="scss">
#not_full_height_ccd {
  .contracts_height_datatable {
    height: 250px;
  }
}
</style>
